/**
 * Used to modify the action an access secure directive will take if
 * the security check fails
 */
export enum SecurityFailureBehavior {
  HIDE,
  DISABLE,
}
